import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APP_NAME, LayoutComponent, SUPPORT_CALLS_ENABLED } from '@elite/layout';
import { HlmToaster } from '@spartan-ng/helm/sonner';
import { AppUpdatePromptComponent } from './app-update-prompt.component';
import { DevToolsGuardService } from './dev-tools-guard.service';
import { SupportCallsComponent } from './calls/support-calls.component';

@Component({
  imports: [RouterModule, LayoutComponent, HlmToaster, AppUpdatePromptComponent, SupportCallsComponent],
  selector: 'elite-root',
  templateUrl: './app.component.html',
  // Angular 22 made OnPush the default; the upgrade migration pinned the old behaviour here.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [DevToolsGuardService],
})
export class AppComponent {
  title = inject(APP_NAME);
  readonly supportCalls = inject(SUPPORT_CALLS_ENABLED);
  // Injecting ensures the service is instantiated and starts watching the store.
  private readonly _devToolsGuard = inject(DevToolsGuardService);
}
